import React, { Component } from 'react';
import {Col, Row} from 'react-bootstrap';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';
import Modal from '../../../components/modal';
import Preloader from '../../../components/preloader';
import EmptyState from '../../../components/empty-state-container';
import IconMenu from '@mui/icons-material/Menu';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';

import {connect} from 'react-redux';

let dbList;

class ManageDatabase extends Component {

  constructor(props) {
    super(props);
    this.state = {
      dbFilterCriteria:"",
      emptyState:"You do not have any DB Connections.",
      deleteDbVal:"",
      modalOpen:false,
      modalTitle:"",
      modalContent:"",
      modalPrimaryButton:"",
      modalSecondaryButton:""
    };
  }


componentDidMount=()=>{
  this.setState({
    dbFilterCriteria:""
  });
}




editDB = (db) => {
    //this.props.getRuleSetContent("edit-account");
    this.props.onClick({db});
}

modalClose=()=>{
  this.setState({
    modalOpen:false
  });
}

modalConfirm=()=>{

  this.setState({
    modalOpen:false
  });
  let deleteObj={
      dbConnectionId:this.state.deleteDbVal.connId,
      dbConnectionName: this.state.deleteDbVal.name
  }
  this.props.deleteDB(deleteObj);
}

deleteItem = (db) => {
    //this.props.getRuleSetContent(value);
    //this.props.onClick(value);
    this.setState({
      modalOpen:true,
      modalTitle:"Delete Connection",
      modalContent:"Are you sure you want to delete \""+db.name+"\"?",
      modalPrimaryButton:"Yes",
      modalSecondaryButton:"No",
      modalState:"delete",
      deleteDbVal:db
    });
}

  createNewConnection = () => {
    this.props.onClick('new');
}





   render() {






     const {isLoading} = this.props;
     let manageDbContent,dbListContent;

     if(isLoading.includes('dblist')){
       manageDbContent=<Preloader loading={true} /> ;
     }
     else if(this.props.dbList !== undefined){

      const filterCriteria=this.state.dbFilterCriteria;
      dbList = this.props.dbList.filter(function (e) {  return e.name.toLowerCase().includes(filterCriteria.toLowerCase()); } );


      if(dbList.length>0){
        dbListContent=<table className='manage-ruleset-table'>
        <tbody>
             {dbList.map((db,index) => <tr key={index}>
               <td onClick={this.editDB.bind(this,db)} className='user' >{db.name}</td>
               <td>
               <IconMenu
                   iconButtonElement={<IconButton size="large"><i className='material-icons'>more_horiz</i></IconButton>}
                   anchorOrigin={{horizontal: 'right', vertical: 'top'}}
                   targetOrigin={{horizontal: 'right', vertical: 'top'}}
                   className='actions-menu'
                 >
                   <MenuItem
                   primaryText="Delete"
                   className='wl-group-card-menu'
                   onClick={this.deleteItem.bind(this,db)}  />
               </IconMenu>
                </td>
               </tr>)}
       </tbody>
        </table>
      }else{
        dbListContent=<EmptyState className="margin-top-0" message={this.state.emptyState} />
      }
       manageDbContent=<Row>

       <Col sm={4} xs={6}>{dbListContent}</Col>
       <Col sm={4} xs={6} className="manage-rule-buttons">

          <Button href=""  onClick={this.createNewConnection.bind(this)} label="Add a new connection" className='createruleset-button'></Button>
       </Col>

       </Row>
     }

     return (
       <div>
       <Modal
        open={this.state.modalOpen}
        title={this.state.modalTitle}
        content={this.state.modalContent}
        primaryButton={this.state.modalPrimaryButton}
        secondaryButton={this.state.modalSecondaryButton}
        close={this.modalClose}
        confirm={this.modalConfirm}
        />
       <div className="manage-ruleset margin-top-30">

       {manageDbContent}

       </div>

         </div>

     );
   }
}


const mapStateToProps = (state) => {
  return{
    isLoading: state.databaseReducer.isLoading,
    errors: state.databaseReducer.errorMessage
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {

  }
}


export default connect(mapStateToProps,mapDispatchToProps) (ManageDatabase);
